'use client';

import LibUserMenu from '@umodeapporg/ui/components/UI/UserMenu';
import { useState } from 'react';
import { useStore } from 'zustand';

import { authRepository } from '@/domain/auth/repositories/authRepository';
import { logout } from '@/infrastructure/http/authRefresh';
import { logger } from '@/infrastructure/persistence/managers/LoggerManager';
import { authStore } from '@/infrastructure/store/authStore';

export function UserMenu() {
  const [open, setOpen] = useState(false);
  const [switchingId, setSwitchingId] = useState<string | null>(null);

  const user = useStore(authStore, (s) => s.user);
  const setUser = useStore(authStore, (s) => s.setUser);
  const partnersList = useStore(authStore, (s) => s.partnersList);

  if (!user) return null;

  const currentPartner = partnersList.find((partner) => partner.partnerId === user.partnerId);

  const handleSwitchAccount = async (partnerId: string): Promise<void> => {
    if (partnerId === user.partnerId || switchingId) return;

    setSwitchingId(partnerId);
    try {
      const updatedUser = await authRepository.switchPartner(partnerId);
      setUser(updatedUser);
      setOpen(false);
    } catch (error) {
      logger.error('[UserMenu] Failed to switch partner', error);
    } finally {
      setSwitchingId(null);
    }
  };

  return (
    <LibUserMenu
      open={open}
      onOpenChange={setOpen}
      userName={user.name}
      userEmail={user.email}
      accountName={currentPartner?.partnerName}
      accountLogoUrl={currentPartner?.partnerLogoImage?.s600}
      roleLabel={user.userRoleName}
      accounts={partnersList.map((partner) => ({
        id: partner.partnerId,
        name: partner.partnerName,
        logoUrl: partner.partnerLogoImage?.s600,
      }))}
      activeAccountId={user.partnerId}
      switchingAccountId={switchingId}
      onSwitchAccount={(partnerId) => {
        void handleSwitchAccount(partnerId);
      }}
      onLogout={logout}
    />
  );
}
